import { getCookie } from '../cookie';

export function checkFirstImp() {
  const firstimp = getCookie('camp_first_impression');

  if (!firstimp) {
    return 'true';
  }
  return 'false';
}
